const validNaicsRegExp = /^[0-9]{2,}$/;

export const isNAICS = (filter: string) => validNaicsRegExp.test(filter);
